'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _selects = require('../common/selects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubjectForm = function (_React$Component) {
	_inherits(SubjectForm, _React$Component);

	function SubjectForm(props) {
		_classCallCheck(this, SubjectForm);

		var _this = _possibleConstructorReturn(this, (SubjectForm.__proto__ || Object.getPrototypeOf(SubjectForm)).call(this, props));

		_this.renderDisciplineSelect = _this.renderDisciplineSelect.bind(_this);
		_this.onNameChange = _this.onNameChange.bind(_this);
		_this.cancel = _this.cancel.bind(_this);
		_this.onClickSubmit = _this.onClickSubmit.bind(_this);
		_this.onDisciplineChange = _this.onDisciplineChange.bind(_this);
		return _this;
	}

	_createClass(SubjectForm, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			var initialState = {
				nameErrorMsg: '',
				disciplineErrorMsg: ''
			};

			if (typeof this.props.subject !== 'undefined') {
				initialState.subject = this.props.subject;
			} else {
				initialState.subject = {
					name: '',
					disciplineId: null
				};
			}

			this.setState(initialState);
		}
	}, {
		key: 'onClickSubmit',
		value: function onClickSubmit() {
			this.props.submit(this.state.subject);
		}
	}, {
		key: 'onNameChange',
		value: function onNameChange(event, value) {
			this.setState({
				subject: _extends({}, this.state.subject, {
					name: value
				})
			});
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.props.cancel();
		}
	}, {
		key: 'onDisciplineChange',
		value: function onDisciplineChange(event, key, value) {
			var subject = this.state.subject;


			this.setState({ subject: _extends({}, subject, { disciplineId: value }) });
		}
	}, {
		key: 'renderDisciplineSelect',
		value: function renderDisciplineSelect() {
			var subject = this.state.subject;


			if (typeof subject.id === 'undefined') {
				if (Object.keys(this.props.disciplines).length === 0) {
					this.props.fetchDisciplinesRequest();
				}

				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement('br', null),
					_react2.default.createElement(_selects.SelectDiscipline, {
						selectedDiscipline: subject.disciplineId,
						disciplineErrorMsg: this.state.disciplineErrorMsg,
						disciplines: this.props.disciplines,
						onSelectDiscipline: this.onDisciplineChange
					})
				);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var requestingCreateSubject = this.props.requestingCreateSubject;
			var _state = this.state,
			    subject = _state.subject,
			    nameErrorMsg = _state.nameErrorMsg;


			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_TextField2.default, {
						hintText: 'Nome',
						floatingLabelText: 'Nome',
						floatingLabelFixed: true,
						onChange: this.onNameChange,
						value: subject.name,
						errorText: nameErrorMsg,
						fullWidth: true
					})
				),
				this.renderDisciplineSelect(),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_RaisedButton2.default, { label: 'Cancelar', onClick: this.cancel }),
					_react2.default.createElement(_RaisedButton2.default, {
						primary: true, label: 'Enviar',
						onClick: this.onClickSubmit,
						style: { marginLeft: '1rem' }
					}),
					requestingCreateSubject && _react2.default.createElement(_CircularProgress2.default, null)
				)
			);
		}
	}]);

	return SubjectForm;
}(_react2.default.Component);

exports.default = SubjectForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/subjects/SubjectForm.js
// module id = 981
// module chunks = 0